class DFIS {
    constructor(
        id,
        name,
        alias,
        description
    ) {
      
        this.id = id;
        this.name = name;
        this.alias = alias;
        this.description = description;
        
    }

    static fromJson({
        dfiId,
        dfiNombre,
        dfiAlias,
        dfiDescripcion
    }) {
        return new DFIS(
            dfiId,
            dfiNombre,
            dfiAlias,
            dfiDescripcion
        );
    }
 
    
}

export default DFIS;
